import { OrganizationUsersState } from "@idw-types/state/organization-users-state";
import { getOrganizationUsersState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getOrganizationUsersDataState = createSelector(getOrganizationUsersState, (state: OrganizationUsersState) => {
    return {
        isLoadingAxnAdminUsers: state.organizationUsers.isLoading,
        axnAdminUsers: state.organizationUsers.organizationUsers,
        organizationUsersRoles: state.organizationUsersRoles
    };
});